import { extractDateAndTimeFromTimestamp } from '../../shared/utilities.js';
import { useLanguage } from '../../context/LanguageContext.js';
import { usei18n } from '../../i18n/i18n.js';
import './DoseEntry.css';

const DoseEntry = ({ dose, active, latest, deletable, onToggle, onEdit, onDelete, onMark }) => {
  const { language } = useLanguage();
  const [date, time] = extractDateAndTimeFromTimestamp(dose.timestamp, language);
  const i18n = usei18n(language);
  const isLetter = Boolean(dose.letter);
  const showGOnlyActions = latest && !isLetter;

  const handleToggle = (e) => {
    if (!latest && !deletable) return;
    e.stopPropagation();
    onToggle();
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit(dose);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete(dose);
  };

  const handleMark = (e) => {
    e.stopPropagation();
    onMark(dose);
  };

  return (
    <div
      className={`dose-entry ${active ? 'active' : ''} ${latest ? 'latest' : ''} ${isLetter ? 'letter' : ''}`}
      onClick={handleToggle}
    >
      <div className="datetime">
        {!isLetter && <p className="date">{date}</p>}
        <p className="time">{time}</p>
      </div>
      <div className="dose-size">
        {dose.letter ? (
          <span className="size letter">{dose.letter}</span>
        ) : (
          <>
            <span className="size">{dose.size}</span>
            <span className="ml">{i18n('doseUnit')}</span>
          </>
        )}
      </div>
      <div className="entry-actions">
        {showGOnlyActions && (
          <button
            type="button"
            className="entry-action edit"
            aria-label={i18n('entryActions.edit')}
            onClick={handleEdit}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z" />
            </svg>
          </button>
        )}
        {deletable && (
          <button
            type="button"
            className="entry-action delete"
            aria-label={i18n('entryActions.delete')}
            onClick={handleDelete}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 3h6" />
              <path d="M4 6h16" />
              <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
              <line x1="10" y1="11" x2="10" y2="17" />
              <line x1="14" y1="11" x2="14" y2="17" />
            </svg>
          </button>
        )}
        {showGOnlyActions && (
          <button
            type="button"
            className="entry-action mark"
            aria-label={i18n('entryActions.mark')}
            onClick={handleMark}
          >
            K
          </button>
        )}
      </div>
    </div>
  )
}

export default DoseEntry;
